import Vue from 'vue';
const { language } = require('./lan/multilingu')

Vue.mixin({
  data() {
    return {
      langType: 'zh_CN'
    }
  },
  mounted() {
    let type = '';
    let lang = window.localStorage.getItem('lang');

    if(this.$route && this.$route.query.lang){
      // 有带参
      type = (this.$route && this.$route.query.lang=='en-US') ?'en':'zh_CN';
    }else if(lang){
      // 有缓存
      type = lang;
    }else{
      // 都没有
      type = 'zh_CN';
    }
    window.localStorage.setItem('lang', type)
    this.langType = type;
  },
  methods: {
    _format(str, args) {
      for (let i = 0; i < args.length; i++) {
        str = str.replace(new RegExp('\\{' + i + '\\}', 'g'), args[i]);
      }
      return str;
    },
    getLang(index, strs) { // 语言
      //if(strs) console.log(222222, index, language[index])
      let returnval;
      console.log('---->', this.langType)
      try {
        returnval = language[index][ this.langType]
      } catch (e) {
        returnval = language['-1'][ this.langType]
      }
      return strs ? this._format(returnval, strs) : returnval;
    },
  },
})


// WEBPACK FOOTER //
// ./src/utils/language.js